import React from 'react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import {
  TextBoxField,
  Select,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Form, Message, Icon, Button, Divider, Grid, List} from 'semantic-ui-react';
import {
  addMemberText,
  addSubMemberText,
  addManSubMemberText,
  email_regex,
} from './constants';
import {withFormik} from 'formik';
import Yup from 'yup';
import RoleAndProgramsContainer from './orgUserRoleProgramContainer';
import _ from 'lodash';
import {checkIfEmailIsFEMA, checkIfEmailIsValid} from 'common/utils';

export const InnerForm = ({
  values,
  errors = {},
  handleBlur,
  handleSubmit,
  handleChange,
  touched,
  addModalVisible,
  toggleModal,
  loading,
  status,
  setStatus,
  profile,
  setFieldError,
  setFieldTouched,
  selectedOrgId,
  selectedUser,
  getUser,
  getSAMUser,
  userNotFound,
  handleUserActions,
  resetState,
  reloadUserList,
  openModal,
  renderMemberInfo,
  getUserData,
  memberInfo,
  programs,
  subOrgUsers,
  subOrgToggle,
  userEmailTableToggle,
  loginGovIntegrationToggle,
  renderType,
  isManuallyAdded,
  parentOrgId,
  toggles,
  orgs,
  orgData,
  parentOrgs,
  displayNameParent,
}) => {
  const notManuallyAddedSubOrg =
    renderType === 'subOrg' && _.toLower(isManuallyAdded) == 'n';

  return (
    <React.Fragment>
      <FemaGoModal
        title={
          renderType === 'subOrg'
            ? 'Give users access to this suborganization'
            : 'Add a new team member to your organization'
        }
        open={addModalVisible}
        size="small"
        className="team-modal"
        id="team-modal"
        closeOnDimmerClick="no"
        confirmButton="hidden"
        cancelAction={() => {
          values.role = '';
          values.email = '';
          profile.isFEMARegistered = '';
          profile.isOrgRegistered = '';
          setFieldError('email', '');
          setFieldError('role', '');
          setFieldTouched('email', false, true);
          setFieldTouched('role', false, true);
          setStatus(null);
          toggleModal('add');
          resetState();
        }}
      >
        {status && <Message negative>{status.errorMsg}</Message>}
        {!loading ? (
          <Form onSubmit={handleSubmit} id="org-team-form">
            <p>
              {renderType === 'subOrg'
                ? !notManuallyAddedSubOrg
                  ? addManSubMemberText
                  : addSubMemberText
                : addMemberText}
            </p>
            {notManuallyAddedSubOrg ? (
              <Select
                size="medium"
                label={<strong>Select a user to add:</strong>}
                title="Enter email"
                name="email"
                id="email"
                options={subOrgUsers}
                handleChange={(e) => getSAMUser(e.target.value)}
                handleBlur={handleBlur}
                value={values.userId}
              />
            ) : (
              <div>
                <TextBoxField
                  size="medium"
                  label={
                    renderType === 'subOrg' ? (
                      <strong>Enter new user's email</strong>
                    ) : (
                      <strong>Enter email</strong>
                    )
                  }
                  title="Enter email"
                  name="email"
                  id="email"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.email}
                  errorMessages={errors.email}
                  displayError={touched.email && errors.email}
                />
                <Button
                  primary
                  title="Enter email"
                  id="enterBtn"
                  onClick={() => {
                    getUser(values.email);
                  }}
                  disabled={
                    checkIfEmailIsFEMA(values.email) ||
                    !values.email ||
                    !checkIfEmailIsValid(values.email)
                  }
                >
                  Enter
                </Button>
              </div>
            )}
            <div className="user-search-result">
              {profile.isFEMARegistered ? (
                renderType == 'subOrg' && subOrgToggle ? (
                  !notManuallyAddedSubOrg ? (
                    loginGovIntegrationToggle ? (
                      <React.Fragment>
                        <b>
                          The email address {profile.searchedEmail} is registered in FEMA
                          GO to {profile.firstName} {profile.lastName}.
                        </b>
                        <br />
                        <br />
                        <span>
                          Is this the person you wish to add to your suborganization?
                        </span>
                        <br />
                        <br />
                        <b>Your colleague's email information:</b>
                        <br />
                        <b>Email for notifications: {profile.email}</b>
                        <br />
                        <b>
                          Other emails:{' '}
                          {_.isEmpty(profile.otherEmails)
                            ? 'N/A'
                            : profile.otherEmails.join(', ')}
                        </b>
                        <br />
                        <br />
                        {handleUserActions(values, profile)}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <h5>This email address is registered in FEMA GO.</h5>
                        <p>Is this the person you wish to add to your suborganization?</p>
                        <h4>{profile.email}</h4>
                        {handleUserActions(values, profile)}
                      </React.Fragment>
                    )
                  ) : (
                    ''
                  )
                ) : loginGovIntegrationToggle ? (
                  <React.Fragment>
                    <b>
                      The email address {profile.searchedEmail} is registered in FEMA GO
                      to {profile.firstName} {profile.lastName}.
                    </b>
                    <br />
                    <br />
                    <span>Is this the person you wish to add to your organization?</span>
                    <br />
                    <br />
                    <b>Your colleague's email information:</b>
                    <br />
                    <b>Email for notifications: {profile.email}</b>
                    <br />
                    <b>
                      Other emails:{' '}
                      {_.isEmpty(profile.otherEmails)
                        ? 'N/A'
                        : profile.otherEmails.join(', ')}
                    </b>
                    <br />
                    <br />
                    {handleUserActions(values, profile)}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <h5>This email address is registered in FEMA GO.</h5>
                    <p>Is this the person you wish to add to your organization?</p>
                    <h4>{profile.email}</h4>
                    {handleUserActions(values, profile)}
                  </React.Fragment>
                )
              ) : profile.isOrgRegistered ? (
                <React.Fragment>
                  <Alert
                    size="small"
                    header="The following member already exists in your organization."
                    content="This user already belongs to your organization. You can find them on the Manage my team page and manage their roles from the 'Manage link'."
                    paragraph={false}
                    type="error"
                    confirmButton="hidden"
                  >
                    <br />
                    <h4>{profile.email}</h4>
                  </Alert>
                  {handleUserActions(values, profile)}
                </React.Fragment>
              ) : userNotFound ? (
                renderType === 'subOrg' ? (
                  <React.Fragment>
                    <h5>
                      This email address is not associated with a registered user in FEMA
                      GO.
                    </h5>
                    <p>
                      You can assign this person roles and provide access to your
                      suborganization. A notice will be sent to the user to complete
                      registration. They will show up on your pending registration list
                      until they register.
                    </p>
                    <p>
                      Is this the person you wish to provide access to your
                      suborganization?
                    </p>
                    <h4>{values.email}</h4>
                    {handleUserActions(values, profile)}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <h5>
                      This email address is not associated with a registered user in FEMA
                      GO.
                    </h5>
                    <p>
                      You can assign this person roles and add them to your organization.
                      A notice will be sent to the user to complete registration. They
                      will show up on your pending registration list until they register.
                    </p>
                    <p>Is this the person you wish to add to your organization?</p>
                    <h4>{values.email}</h4>
                    {handleUserActions(values, profile)}
                  </React.Fragment>
                )
              ) : null}
            </div>
            {renderType == 'subOrg' && subOrgToggle && selectedUser && (
              <div>
                <strong>
                  {selectedUser.firstName} {selectedUser.lastName}
                </strong>
                <br />
                {selectedUser.emailAdr || selectedUser.userId}
              </div>
            )}
            {profile.showRole ? (
              <React.Fragment>
                <Divider className="hr-dotted" />
                <RoleAndProgramsContainer
                  selectedOrgId={selectedOrgId}
                  userNotFound={userNotFound}
                  userId={
                    notManuallyAddedSubOrg
                      ? selectedUser.userId
                      : userEmailTableToggle && profile.userId
                      ? profile.userId
                      : values.email
                  }
                  toggleModal={toggleModal}
                  resetState={resetState}
                  reloadUserList={reloadUserList}
                  renderMemberInfo={renderMemberInfo}
                  getUserData={getUserData}
                  programs={programs}
                  subOrgToggle={subOrgToggle}
                  renderType={renderType}
                  parentOrgId={parentOrgId}
                  toggles={toggles}
                  orgs={orgs}
                  parentOrgs={parentOrgs}
                  displayNameParent={displayNameParent}
                />
              </React.Fragment>
            ) : null}
          </Form>
        ) : (
          <div>Loading entities</div>
        )}
      </FemaGoModal>
      {openModal === 'success' ? (
        <FemaGoModal
          title="New team member successfully added"
          open={openModal === 'success'}
          size="small"
          cancelButtonText="Close"
          buttonText="OK"
          closeOnDimmerClick="no"
          confirmAction={() => {
            values.email = '';
            renderMemberInfo('none');
            toggleModal('add');
            resetState();
          }}
          cancelAction={() => {
            values.email = '';
            renderMemberInfo('none');
            toggleModal('add');
            resetState();
            reloadUserList();
          }}
        >
          <Alert
            size="small"
            header={`The following user has been added to your organization 
              ${
                subOrgToggle && renderType == 'subOrg'
                  ? orgData
                    ? orgData.displayName
                    : ''
                  : memberInfo.entity
              }:`}
            paragraph={false}
            type="success"
            confirmButton="hidden"
          >
            <div id="team-notification" className="team-notification-content">
              <h5>{profile.email}</h5>
              <Grid>
                {_.map(memberInfo.user, (member, index) => {
                  return (
                    <Grid.Row columns={3} className="roles-info" key={index}>
                      <Grid.Column>
                        <small>
                          <strong>{`Role ${index + 1}`}</strong>
                        </small>
                        <p>{member.roles}</p>
                      </Grid.Column>
                      {_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                        member.parent != '' ? (
                          <Grid.Column>
                            <small>
                              <strong>{`Parent Organization `}</strong>
                            </small>
                            <p>{displayNameParent(member.parent, parentOrgs)}</p>
                          </Grid.Column>
                        ) : null
                      ) : null}
                      {_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                        <Grid.Column>
                          <small>
                            <strong>
                              Program{_.size(member.programs) == 1 ? '' : 's'}
                            </strong>
                          </small>
                          <List>
                            {_.size(member.programs) === 0 && (
                              <List.Item>All Programs</List.Item>
                            )}
                            {_.map(member.programs, (progId, index) => (
                              <List.Item key={index}>
                                {
                                  _.find(
                                    programs,
                                    (program) => program.programId === progId.programId
                                  ).programName
                                }
                              </List.Item>
                            ))}
                          </List>
                        </Grid.Column>
                      ) : (
                        ''
                      )}
                    </Grid.Row>
                  );
                })}
              </Grid>
            </div>
          </Alert>
        </FemaGoModal>
      ) : (
        <FemaGoModal
          title="Registration notification sent"
          open={openModal === 'notify'}
          size="small"
          buttonText="OK"
          cancelButtonText="Close"
          closeOnDimmerClick="no"
          confirmAction={() => {
            values.email = '';
            renderMemberInfo('none');
            toggleModal('add');
            resetState();
          }}
          cancelAction={() => {
            values.email = '';
            renderMemberInfo('none');
            toggleModal('add');
            resetState();
            reloadUserList();
          }}
        >
          <Alert
            size="small"
            header={
              'A notification to complete registration has been sent to the following email address:'
            }
            paragraph={false}
            type="info"
            dismissable={false}
          >
            <div id="team-notification">
              <h5>{memberInfo.email ? memberInfo.email : values.email}</h5>
              {_.map(memberInfo.user, (member, index) => {
                return (
                  <Grid.Row columns={2} className="roles-info" key={index}>
                    <Grid.Column>
                      <div className="roles-info" key={index}>
                        <small>
                          <strong>{`Role ${index + 1}`}</strong>
                        </small>
                        <p>{member.roles}</p>
                      </div>
                    </Grid.Column>
                    {_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                      member.parent != '' ? (
                        <Grid.Column>
                          <small>
                            <strong>{`Parent Organization `}</strong>
                          </small>
                          <p>{displayNameParent(member.parent, parentOrgs)}</p>
                        </Grid.Column>
                      ) : null
                    ) : null}
                    {_.includes(toggles, 'manageTeamOrgSubOrg') ? (
                      <Grid.Column>
                        <small>
                          <strong>
                            Program{_.size(member.programs) == 1 ? '' : 's'}
                          </strong>
                        </small>
                        <List>
                          {_.size(member.programs) === 0 && (
                            <List.Item>All Programs</List.Item>
                          )}
                          {_.map(member.programs, (progId, index) => (
                            <List.Item key={index}>
                              {
                                _.find(
                                  programs,
                                  (program) => program.programId === progId.programId
                                ).programName
                              }
                            </List.Item>
                          ))}
                        </List>
                      </Grid.Column>
                    ) : (
                      ''
                    )}
                  </Grid.Row>
                );
              })}
            </div>
          </Alert>
        </FemaGoModal>
      )}
    </React.Fragment>
  );
};

export const withSemanticUIFormik = (props, values) => (WrappedComponent) => {
  return withFormik(
    props,
    values
  )(
    class extends React.Component {
      handleChange = (e, data) => {
        if (data && data.name) {
          if (data.value === '') {
            this.props.resetState();
          }
          this.props.setFieldValue(data.name, data.value);
        }
      };
      handleUserActions = (values, profile) => {
        return (
          <React.Fragment>
            {!profile.isOrgRegistered ? (
              <Button
                primary
                id="yesBtn"
                name="yes"
                onClick={this.props.handleRole(profile)}
                disabled={
                  checkIfEmailIsFEMA(values.email) ||
                  !values.email ||
                  !checkIfEmailIsValid(values.email)
                }
              >
                Yes
              </Button>
            ) : (
              <Button
                primary
                id="closeWindowBtn"
                name="close"
                onClick={() => {
                  values.email = '';
                  this.props.toggleModal('add');
                  this.props.resetState();
                }}
              >
                Close window
              </Button>
            )}
            <a
              id="enterNewEmail"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                values.email = '';
                this.props.resetState();
              }}
            >
              <Icon name="undo" color="blue" />
              Enter another email address
            </a>
          </React.Fragment>
        );
      };
      render() {
        return (
          <React.Fragment>
            <WrappedComponent
              {...this.props}
              loading={this.props.loading}
              handleChange={this.handleChange}
              setFieldValue={this.props.setFieldValue}
              addModalVisible={this.props.addModalVisible}
              getUser={this.props.getUser}
              userNotFound={this.props.userNotFound}
              handleUserActions={this.handleUserActions}
              resetState={this.props.resetState}
              reloadUserList={this.props.reloadUserList}
              selectedOrgId={this.props.selectedOrgId}
              renderMemberInfo={this.props.renderMemberInfo}
              openModal={this.props.openModal}
              getUserData={this.props.getUserData}
              memberInfo={this.props.memberInfo}
              programs={this.props.programs}
              subOrgToggle={this.props.subOrgToggle}
              renderType={this.props.renderType}
              toggles={this.props.toggles}
              orgs={this.props.orgs}
            />
          </React.Fragment>
        );
      }
    }
  );
};

export const AddOrgUserForm = withSemanticUIFormik({
  mapPropsToValues: (props) => {
    return {
      email: '',
      role: '',
      profile: {},
    };
  },
  validationSchema: (props) =>
    Yup.object().shape({
      email: Yup.mixed()
        .required('Please enter a valid email address')
        .test('is-valid-email', 'Please enter a valid email address', (value) => {
          return email_regex.test(value);
        })
        .test(
          'is-nonfema-email',
          'Please enter a valid Non-FEMA email address',
          (value) => {
            if (value !== undefined) {
              return !checkIfEmailIsFEMA(value);
            }
          }
        ),
      role: Yup.string().required('Please select a role'),
    }),

  handleSubmit: async (values, {props, setStatus, setSubmitting}) => {
    setSubmitting(true);
  },
})(InnerForm);
export default AddOrgUserForm;
